var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIbmLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 40,
    viewBox: "0 0 63 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.2578H12.1173V24.9924H0V23.2578Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.9297H12.1173V21.6704H0V19.9297Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45312 16.6094H8.65063V18.3501H3.45312V16.6094Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45312 13.2891H8.65063V15.0298H3.45312V13.2891Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45312 9.96875H8.65063V11.7095H3.45312V9.96875Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45312 6.64062H8.65063V8.38137H3.45312V6.64062Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1173 3.32031H0V5.06106H12.1173V3.32031Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1173 0H0V1.74075H12.1173V0Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8438 21.6704H32.4795C32.7943 21.1334 33.0289 20.547 33.1709 19.9297H13.8438V21.6704Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0269 13.2891H17.3047V15.0298H32.4775C32.0824 14.3631 31.5948 13.7767 31.0269 13.2891Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3047 9.96875V11.7095H31.0269C31.6072 11.2218 32.0948 10.6354 32.4775 9.96875H17.3047Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4796 3.32031H13.8438V5.06106H33.1709C33.0104 4.44377 32.7759 3.85739 32.4796 3.32031Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7512 0H13.8438V1.74075H31.2018C30.0413 0.666648 28.4672 0 26.7512 0Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.496 6.64062H17.3047V8.38137H22.496V6.64062Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6953 8.38137H33.1274C33.2817 7.82585 33.362 7.23941 33.362 6.64062H27.6953V8.38137Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3047 16.6094H22.496V18.3501H17.3047V16.6094Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6953 16.6094V18.3501H33.362C33.362 17.7513 33.2817 17.165 33.1274 16.6094H27.6953Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8438 24.9801L26.7512 24.9986C28.4796 24.9986 30.0413 24.3319 31.2079 23.2578H13.8438V24.9801Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.625 23.2578H43.2793V24.9924H34.625V23.2578Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.625 19.9297H43.2793V21.6704H34.625V19.9297Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0781 16.6094H43.2756V18.3501H38.0781V16.6094Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0781 13.2891H43.2756V15.0298H38.0781V13.2891Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6867 3.32031H34.625V5.06106H46.2854L45.6867 3.32031Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5385 0H34.625V1.74075H45.1373L44.5385 0Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6641 23.2578H62.3246V24.9924H53.6641V23.2578Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6641 19.9297H62.3246V21.6704H53.6641V19.9297Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6641 16.6094H58.8616V18.3501H53.6641V16.6094Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6641 13.2891H58.8616V15.0298H53.6641V13.2891Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6584 11.7095H58.8559V9.96875H53.6584H48.9547L48.467 11.3762L47.9794 9.96875H43.2756H38.0781V11.7095H43.2756V10.1107L43.8251 11.7095H53.109L53.6584 10.1107V11.7095Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8596 6.64062H50.1066L49.5078 8.38137H58.8596V6.64062Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4113 0L51.8125 1.74075H62.3249V0H52.4113Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4738 24.9801L49.0725 23.2578H47.875L48.4738 24.9801Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3221 21.6704H49.6183L50.2356 19.9297H46.7109L47.3221 21.6704Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M46.158 18.3501H50.7876L51.3988 16.6094H45.5469L46.158 18.3501Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9972 15.0298H51.954L52.5466 13.2891H44.3984L44.9972 15.0298Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0781 8.38137H47.43L46.8312 6.64062H38.0781V8.38137Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6641 5.06106H62.3246V3.32031H51.2567L50.6641 5.06106Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbmLight);
export default __webpack_public_path__ + "static/media/ibm_light.1a4396f83b0e628d2a8ffb35613f87da.svg";
export { ForwardRef as ReactComponent };